import React, { useState, useEffect } from 'react';
import { Youtube, Instagram, ArrowUp } from 'lucide-react';
import { socialLinks } from '../data/mockData';

const FloatingButtons = () => {
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 300);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <>
      {/* Social Floating Buttons */}
      <div className="fixed right-6 bottom-6 z-40 flex flex-col space-y-3">
        {/* YouTube Button */}
        <a 
          href={socialLinks.youtube}
          target="_blank"
          rel="noopener noreferrer"
          className="group bg-red-600 hover:bg-red-700 text-white w-14 h-14 rounded-full flex items-center justify-center shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:scale-110"
          title="Assista aulas gratuitas no YouTube"
        >
          <Youtube size={24} />
          <span className="absolute right-16 bg-gray-900 text-white px-3 py-2 rounded-lg text-sm font-medium opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap">
            YouTube
          </span>
        </a>

        {/* Instagram Button */}
        <a 
          href={socialLinks.instagram}
          target="_blank"
          rel="noopener noreferrer"
          className="group bg-gradient-to-br from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white w-14 h-14 rounded-full flex items-center justify-center shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:scale-110"
          title="Siga no Instagram"
        >
          <Instagram size={24} />
          <span className="absolute right-16 bg-gray-900 text-white px-3 py-2 rounded-lg text-sm font-medium opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap">
            Instagram
          </span>
        </a>

        {/* Scroll to Top Button */}
        {showScrollTop && (
          <button 
            onClick={scrollToTop}
            className="group bg-orange-500 hover:bg-orange-600 text-white w-14 h-14 rounded-full flex items-center justify-center shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:scale-110 animate-bounce"
            title="Voltar ao topo"
          >
            <ArrowUp size={24} />
          </button>
        )}
      </div>
    </>
  );
};

export default FloatingButtons;
